import { render, staticRenderFns } from "./MessageContextMenu.vue?vue&type=template&id=3ae18178&scoped=true&"
import script from "./MessageContextMenu.vue?vue&type=script&lang=js&"
export * from "./MessageContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./MessageContextMenu.vue?vue&type=style&index=0&id=3ae18178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae18178",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae18178')) {
      api.createRecord('3ae18178', component.options)
    } else {
      api.reload('3ae18178', component.options)
    }
    module.hot.accept("./MessageContextMenu.vue?vue&type=template&id=3ae18178&scoped=true&", function () {
      api.rerender('3ae18178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/conversations/components/MessageContextMenu.vue"
export default component.exports